import { useEffect } from 'react'

const useCleanupLocalStorage = (keys) => {
  useEffect(() => {
    keys.forEach((key) => localStorage.removeItem(key))
  }, [])
}

export default useCleanupLocalStorage
